import { Trans } from 'react-i18next';
import styled from 'styled-components';
import { type ListItemProps } from '../context';

const List = styled.li`
    list-style-type: square;
    margin: 0 0 0 15px !important;
    &::marker {
        font-size: 14px;
    }
`;

const ListItem = ({ translationKey }: ListItemProps) => (
    <ul>
        <Trans components={{ l: <List /> }} i18nKey={translationKey} />{' '}
    </ul>
);

export default ListItem;
